import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import AuthPage from "@/pages/AuthPage";
import PendingPage from "@/pages/PendingPage";
import CommunityPage from "@/pages/CommunityPage";
import ClassroomPage from "@/pages/ClassroomPage";
import CoursePage from "@/pages/CoursePage";
import EventsPage from "@/pages/EventsPage";
import MembersPage from "@/pages/MembersPage";
import MemberProfilePage from "@/pages/MemberProfilePage";
import MessagesPage from "@/pages/MessagesPage";
import GroupsPage from "@/pages/GroupsPage";
import GroupPage from "@/pages/GroupPage";
import ProfilePage from "@/pages/ProfilePage";
import AdminPage from "@/pages/AdminPage";

const Loader = () => (
  <div className="min-h-screen grid place-items-center" data-testid="app-loading">
    <img src="/brand/logo.png" alt="Hey Boo!" className="w-28 animate-pulse" />
  </div>
);

const Protected = () => {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin" && user.status !== "approved") return <PendingPage />;
  return <AppShell />;
};

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  return user?.role === "admin" ? children : <Navigate to="/" replace />;
};

const LoginRoute = () => {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  return user ? <Navigate to="/" replace /> : <AuthPage />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/" element={<Protected />}>
            <Route index element={<CommunityPage />} />
            <Route path="groups" element={<GroupsPage />} />
            <Route path="groups/:groupId" element={<GroupPage />} />
            <Route path="classroom" element={<ClassroomPage />} />
            <Route path="classroom/:courseId" element={<CoursePage />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="members" element={<MembersPage />} />
            <Route path="members/:memberId" element={<MemberProfilePage />} />
            <Route path="messages" element={<MessagesPage />} />
            <Route path="messages/:memberId" element={<MessagesPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="admin" element={<AdminOnly><AdminPage /></AdminOnly>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" richColors />
    </AuthProvider>
  );
}

export default App;
